import { PureLightTheme } from "../../styles/theme";

export const containerStyles = {
  alignItems: "flex-start",
};

export const paperCenterStyles = {
  margin: "auto",
  minWidth: "756px",
  [PureLightTheme.breakpoints.down("lg")]: {
    margin: "auto",
    minWidth: "600px",
  },
  [PureLightTheme.breakpoints.down("md")]: {
    margin: "auto",
    minWidth: "556px",
  },
  [PureLightTheme.breakpoints.down("sm")]: {
    margin: "auto",
    minWidth: "calc(100% - 32px)",
  },
  borderRadius: "16px",
};
export const paperRightHalfStyles = {
  margin: 0,
  position: "fixed",
  top: "16px",
  right: "8px",
  width: "656px",
  minWidth: "656px",
  height: "calc(100vh - 32px)",
  maxHeight: "calc(100vh - 32px)",
  borderRadius: "16px",
  boxShadow: 3,
  overflowY: "auto",

  [PureLightTheme.breakpoints.down("md")]: {
    position: "relative",
    margin: "auto",
    right: "unset",
    width: "556px",
    height: "auto",
    maxHeight: "90vh",
  },

  [PureLightTheme.breakpoints.down("sm")]: {
    margin: "auto",
    minWidth: "calc(100% - 32px)",
    width: "calc(100% - 32px)",
  },
};

export const paperStyles = {
  margin: "auto",
  minWidth: "656px",
  [PureLightTheme.breakpoints.down("lg")]: {
    // marginTop: "200px",
    minWidth: "600px",
  },
  [PureLightTheme.breakpoints.down("md")]: {
    // marginTop: "200px",
    minWidth: "556px",
  },
  [PureLightTheme.breakpoints.down("sm")]: {
    // marginTop: "150px",
    minWidth: "calc(100% - 32px)",
  },
  borderRadius: "16px",
};

/**
 * Центрирование по экрану, min ~80vh, при переполнении — до почти fullscreen (полоса поля по краю).
 */
export const paperStylesTallCentered = {
  margin: "auto",
  minHeight: "80vh",
  maxHeight: "calc(100dvh - 16px)",
  width: "min(656px, calc(100vw - 32px))",
  maxWidth: "100%",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  borderRadius: "16px",

  [PureLightTheme.breakpoints.down("sm")]: {
    width: "calc(100vw - 16px)",
  },
};

export const paperStylesFullWH = {
  marginTop: "10px",
  minWidth: "98%",
  [PureLightTheme.breakpoints.down("lg")]: {
    marginTop: "5%",
    minWidth: "98%",
  },
  [PureLightTheme.breakpoints.down("md")]: {
    marginTop: "5%",
    minWidth: "98%",
  },
  [PureLightTheme.breakpoints.down("sm")]: {
    marginTop: "5%",
    minWidth: "98%",
  },
  borderRadius: "16px",
};

export const titleStyles = {
  padding: "32px 32px 16px",
  [PureLightTheme.breakpoints.down("lg")]: {
    padding: "32px 28px 16px",
  },
  [PureLightTheme.breakpoints.down("md")]: {
    padding: "32px 24px 16px",
  },
};

export const bodyStyles = {
  maxWidth: "100%",
  padding: "0 32px 32px",
  overflowY: "auto", // Добавляем прокрутку при необходимости
  [PureLightTheme.breakpoints.down("lg")]: {
    padding: "0 28px 28px",
  },
  [PureLightTheme.breakpoints.down("md")]: {
    padding: "0 24px 24px",
  },
};

export const actionsStyles = {
  padding: "0 32px 32px",
  [PureLightTheme.breakpoints.down("lg")]: {
    padding: "0 28px 32px",
  },
  [PureLightTheme.breakpoints.down("md")]: {
    padding: "0  24px 32px",
  },
  justifyContent: "initial",
};

export const buttonWrapStyles = {
  flexDirection: "row",
  gap: "8px",
  width: "100%",
  justifyContent: "flex-end",
  [PureLightTheme.breakpoints.down("sm")]: {
    justifyContent: "initial",
    flexDirection: "column",
  },
};

export const btnStyle = {
  borderRadius: "16px",
  fontSize: "14px",
  height: "40px",
  padding: "10px 20px",
  [PureLightTheme.breakpoints.down("lg")]: {
    borderRadius: "16px",
    fontSize: "14px",
    padding: "10px 20px",
  },
  [PureLightTheme.breakpoints.down("md")]: {
    borderRadius: "16px",
    fontSize: "14px",
    padding: "10px 16px",
  },
};
